import Vue from 'vue'
import Router from 'vue-router'
import login from '../pages/login/login'

// 考试列表模块
import Testlist from '../pages/testlists/testlist.vue'
import Testpaper from '../pages/testlists/testpaper.vue'
import attention from '../pages/testlists/attention.vue'
import submit from '../pages/testlists/submit.vue'
import scorelist from '../pages/testlists/scorelist.vue'

// 考试记录
import Record from '../pages/records/recordlist.vue'
import Recordpaper from '../pages/records/Recordpaper.vue'
import Recordtestpaper from '../pages/records/testpaper.vue'

//考试管理
import Managelist from '../pages/namnege/manegelist.vue'
import Goverpaper from '../pages/namnege/gooverpaper.vue'
import publicpaper from '../pages/namnege/publicpaper.vue'
import publiclist from '../pages/namnege/publiclist.vue'
import normalpaper from '../pages/namnege/normalpaper.vue'
import selectpaper from '../pages/namnege/selectpaper.vue'
import radompaper from '../pages/namnege/radompaper.vue'
// 试题管理
import issuelist from '../pages/issue/issuelist.vue'
import issueadd from '../pages/issue/issueadd.vue'

// 统计管理
import userslist from '../pages/statistics/userslist.vue'
import jointestslist from '../pages/statistics/jointestslist.vue'
import testsrecord from '../pages/statistics/testsrecord.vue'
import recordslist from '../pages/statistics/recordslist.vue'
import anaslyse from '../pages/statistics/anaslyse.vue'
import managerlist from '../pages/system/managelist.vue'
import powerlist from '../pages/system/powerlist.vue'

// 浏览试卷
import scanpaper from '../pages/scan/scanpaper.vue'
import scanexam from '../pages/scan/scanexam.vue'
// 权限设定
import powerset from '../pages/system/powerset.vue'
import knowledgePoints from '../pages/system/knowledagePoints.vue'
import classmanage from '../pages/system/classManage.vue'

//解决冗余导航问题，使用push和replace方法

//push的方法
const RouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return RouterPush.call(this, to).catch(err => err)
}

//replace的方法
const RouterReplace = Router.prototype.replace
Router.prototype.replace = function replace (to) {
  return RouterReplace.call(this, to).catch(err => err)
}


Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [{
      path: '/',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    // 考试列表
    {
      path: '/examlists',
      name: 'Testlist',
      component: Testlist
    },
    {
      path: '/attention',
      name: 'attention',
      component: attention
    },
    {
      path: '/exampaper',
      name: 'Testpaper',
      component: Testpaper
    },
    {
      path: '/submit',
      name: 'submit',
      component: submit
    },
    {
      path: '/scorelist',
      name: 'scorelist',
      component: scorelist
    },
    // 考试记录
    {
      path: '/examrecords',
      name: 'Testrecord',
      component: Record
    },
    {
      path: '/recordexampaper',
      name: 'Recordexampaper',
      component: Recordtestpaper
    },
    {
      path: '/recordpaper',
      name: 'Recordpaper',
      component: Recordpaper
    },
    // 考试管理
    {
      path: '/managelist',
      name: 'Managelist',
      component: Managelist
    },
    // 阅卷详情
    {
      path: '/gooverpaper',
      name: 'Goverpaper',
      component: Goverpaper
    },
    // 发布考试
    {
      path: '/manage/publicpaper',
      name: 'publicpaper',
      component: publicpaper
    },
    {
      path: '/manage/publiclist',
      name: 'publiclist',
      component: publiclist
    },
    // 创建普通试卷
    {
      path: '/manage/normalpaper',
      name: 'normalpaper',
      component: normalpaper
    },
    // 创建抽题试卷
    {
      path: '/manage/selectpaper',
      name: 'selectpaper',
      component: selectpaper
    },
    // 创建随机试卷
    {
      path: '/manage/radompaper',
      name: 'radompaper',
      component: radompaper
    },
    // 题库列表 issuelist
    {
      path: '/manage/issuelist',
      name: 'issuelist',
      component: issuelist
    },
    // 题库添加试题 issueadd 
    {
      path: '/manage/issueadd',
      name: 'issueadd',
      component: issueadd
    },


    // 统计管理
    {
      path: '/userslist',
      name: 'userslist',
      component: userslist
    },
    {
      path: '/joinexamslist',
      name: 'joinexamslist',
      component: jointestslist
    },
    {
      path: '/examsrecord',
      name: 'examsrecord',
      component: testsrecord
    },
    {
      path: '/anaslyse',
      name: 'anaslyse',
      component: anaslyse
    },
    //考试列表--------> 考试记录
    {
      path: '/recordslist',
      name: 'recordslist',
      component: recordslist
    },
    // 系统设置--
    {
      path: '/managerlist',
      name: 'managerlist',
      component: managerlist
    },
    {
      path: '/powerlist',
      name: 'powerlist',
      component: powerlist
    },
    {
      path: '/powerlist',
      name: 'powerlist',
      component: powerlist
    },
    {
      path: '/knowledgePoints',
      name: 'knowledgePoints',
      component: knowledgePoints
    },
    // 预览设置
    {
      path: '/scanpaper',
      name: 'scanpaper',
      component: scanpaper
    },
    {
      path: '/scanexam',
      name: 'scanexam',
      component: scanexam
    },
    // 权限设定powerset
    {
      path: '/powerset',
      name: 'powerset',
      component: powerset
    },
    //  classmanage
    {
      path: '/classmanage',
      name: 'classmanage',
      component: classmanage
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js